/**
 * Bright daytime sky with softly drifting 3D-depth clouds and a warm sun glow.
 * Pure CSS (see App.css: .sky-bg / .cloud-track / .cloud). Clouds sit at
 * different scales, blurs and speeds to create parallax depth. Motion pauses
 * for users who prefer reduced motion.
 */
const CLOUDS = ["a", "b", "c", "d", "e", "f"];

export const SkyBackground = () => (
  <div className="sky-bg" aria-hidden="true" data-testid="hero-sky-background">
    <div className="sky-sun" />
    <div className="sky-haze" />
    {CLOUDS.map((key) => (
      <div key={key} className={`cloud-track cloud-track--${key}`}>
        <span className="cloud" />
      </div>
    ))}
  </div>
);
